import React, { Component } from 'react';
import { observer , inject } from 'mobx-react';
import NoteListItem from '../component/NoteListItem';
import {Menu , MenuDivider, MenuItem,Button, Icon,Intent}from '@blueprintjs/core';


@inject("store")
@observer
export default class NoteList extends Component
{

    constructor(props){
        super(props);
        this.state = { "changing":1 };
       
        
    }
    componentWillReceiveProps(nextProps){
        this.setState({"chaging":this.props.store.starchange})
    
     
      }
    render()
    {
        return   <div className = "notelist">
                { this.props.store.current_note_list && this.props.store.current_note_list.map( item => <NoteListItem changing = {this.state.chaging} data={item} key={item._id} /> ) }

        </div>;
    }
}